import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AgentCallAttended from "../../shared/widges/agentcall/agentcallAttended";
import { CallPopUpAgentActions } from "../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../services/call_service";
import CallTransferSuccess from "../../shared/widges/calltransfersuccess";
import CallTransferTab from "../../shared/widges/agentcall/callTransferTab";
import { Cookie } from "../../base/utils";
import DialpadnumberNew from "../../shared/widges/agentcall/transferKeypad/dialpadNumber";
import Draggable from "react-draggable";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";
import DialpadDtmf from "../../shared/widges/agentcall/transferKeypad/dialpadNumberdtmf";
import CallTransferFailed from "../../shared/widges/callTransferredFailed";

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}
function OncallPad({ resetTrigger }: any) {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { dialPadChanges } = CallService(dispatch, navigate);

  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const { isDialPadOpen, isCalling, isTransfer, isTransferSuccess, status, incomingCallDetail, isCallTransferFailed } = popUpDetails;





  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const Draggable1: any = Draggable;
  const [doShowClose, setDoShowClose] = useState<any>(false);
  const [isclicked, setIsclicked] = useState(false);


  const closeDialPad = () => {
    setIsclicked(false);
    dispatch(CallPopUpAgentActions.setNumber(''));
    dispatch(CallPopUpAgentActions.setQueueName(''));
    dispatch(CallPopUpAgentActions.closeDialPad());
    if (isTransfer) {
      dispatch(CallPopUpAgentActions.closeTransfer());
    }
  };

  const doShowFunc = () => {
    setDoShowClose(true);
  };

  const doHideFunc = () => {
    setDoShowClose(false);
  };
  const draggableRef: any = useRef(null);

  useEffect(() => {
    if (resetTrigger) {
      resetPosition();
    }
  }, [resetTrigger]);

  const resetPosition = () => {
    if (draggableRef.current) {
      draggableRef.current.setState({ x: 0, y: 0 }); // Reset position
    }
  };

  const width = useWindowWidth();
  return (
    // <div className="callClickBtn" onMouseOver={doShowFunc} onMouseLeave={doHideFunc}>
    //   {window.location.pathname !== "/login" && window.location.pathname !== "/" && (
    //     <Draggable1>
    //       <>
    //         {isDialPadOpen && !incomingCallDetail?.guid && (
    //           <div className="voiceCallSec voicecallbor bdrrds headerdialpadcontainer ">
    //             <div className="callSec topbarCall">
    //               <p className="closeview">{doShowClose && <span className={`icon__closeiconblack24 closeDialpad`} onClick={closeDialPad}></span>}</p>
    //               <div className="headerdialpad">
    //               <DialpadnumberNew />

    //               </div>
    //               <DialpadDtmf/>
    //             </div>
    //             {doShowClose && <span className={`icon__Close16 closeDialpad`} onClick={closeDialPad}></span>}
    //           </div>
    //         )}

    //         {isCalling && incomingCallDetail?.guid && (
    //           <div className="voiceCallSec voicecallbor">
    //             <AgentCallAttended />
    //           </div>
    //         )}

    //         {isTransfer && (
    //           <>
    //             <div className="voiceCallSec voicecallbor">
    //               <CallTransferTab />
    //             </div>
    //           </>
    //         )}

    //         {isTransferSuccess && (
    //           <div className="voiceCallSec voicecallbor">
    //             <CallTransferSuccess />
    //           </div>
    //         )}
    //       </>


    //       {isDialPadOpen && !isCalling ? (
    //         <div className="voiceCallSec voicecallbor bdrrds">
    //           <div className="callSec topbarCall">
    //             {doShowClose && <span className={`icon__CloseWhite24 closeDialpad`} onClick={closeDialPad}></span>}

    //             <DialpadnumberNew />
    //           </div>
    //         </div>
    //       ) : !isDialPadOpen && isCalling && isTransfer ? (
    //         <>
    //           <div className="voiceCallSec voicecallbor">
    //             <CallTransferTab />
    //           </div>
    //         </>
    //       ) : isTransferSuccess ? (
    //         <div className="voiceCallSec voicecallbor">
    //           <CallTransferSuccess />
    //         </div>
    //       ) : (
    //         <>
    //           {isCalling && (
    //             <>
    //               <div className="voiceCallSec voicecallbor">
    //                 <AgentCallAttended />
    //               </div>
    //             </>
    //           )}
    //         </>
    //       )}
    //     </Draggable1>
    //   )}
    // </div>
    // <div className="draggabledialpad" >
    <div className=" callClickBtn draggabledialpad" onMouseOver={doShowFunc} onMouseLeave={doHideFunc}>
      <Draggable1 ref={draggableRef} disabled={width <= 767}>
        <div className="content">
          {window.location.pathname !== "/login" && window.location.pathname !== "/" && (
            <Draggable1 disabled={width <= 767}>
              <>
                {isDialPadOpen && !incomingCallDetail?.guid && (
                  <div className="voiceCallSec voicecallbor bdrrds headerdialpadcontainer ">
                    <div className="callSec topbarCall">
                      <p className="closeview">{doShowClose && <span className={`icon__closeiconblack24 closeDialpad`} onClick={closeDialPad}></span>}</p>
                      <div className="headerdialpad">
                        <DialpadnumberNew />

                      </div>
                      {/* <DialpadDtmf/> */}
                    </div>
                    {/* {doShowClose && <span className={`icon__Close16 closeDialpad`} onClick={closeDialPad}></span>} */}
                  </div>
                )}

                {isCalling && incomingCallDetail?.guid && (
                  <div className="voiceCallSec voicecallbor">
                    <AgentCallAttended />
                  </div>
                )}

                {isTransfer && (
                  <>
                    <div className="voiceCallSec voicecallbor">
                      <CallTransferTab />
                    </div>
                  </>
                )}

                {isTransferSuccess && (
                  <div className="voiceCallSec voicecallbor">
                    <CallTransferSuccess />
                  </div>
                )}
                {isCallTransferFailed && (
                  <div className="voiceCallSec voicecallbor">
                    <CallTransferFailed />
                  </div>
                )}
              </>

              {/*           
          {isDialPadOpen  && !isCalling ? (
            <div className="voiceCallSec voicecallbor bdrrds">
              <div className="callSec topbarCall">
                {doShowClose && <span className={`icon__CloseWhite24 closeDialpad`} onClick={closeDialPad}></span>}

                <DialpadnumberNew />
              </div>
            </div>
          ) : !isDialPadOpen && isCalling && isTransfer ? (
            <>
              <div className="voiceCallSec voicecallbor">
                <CallTransferTab />
              </div>
            </>
          ) : isTransferSuccess ? (
            <div className="voiceCallSec voicecallbor">
              <CallTransferSuccess />
            </div>
          ) : (
            <>
              {isCalling && (
                <>
                  <div className="voiceCallSec voicecallbor">
                    <AgentCallAttended />
                  </div>
                </>
              )}
            </>
          )} */}
            </Draggable1>
          )}
        </div>
      </Draggable1>
    </div>
  );
}

export default OncallPad;
